export const STATUS_LABEL_SUGGESTIONS: Record<string, string[]> = {
  Submitted: ['Logged', 'Received', 'New', 'Open'],
  'Under Review': ['Reviewing', 'Triage', 'Assessing', 'Evaluating'],
  Approved: ['Accepted', 'Greenlit', 'Authorized', 'Cleared'],
  Assigned: ['Allocated', 'Dispatched', 'Tasked', 'Assigned to trade'],
  Scheduled: ['Booked', 'Appointment set', 'Planned', 'Slotted'],
  'En Route': ['On the way', 'Travelling', 'Heading over', 'Inbound'],
  'In Progress': ['Underway', 'Active', 'Working', 'Started'],
  'On Hold': ['Paused', 'Waiting', 'On pause', 'Stalled'],
  Declined: ['Rejected', 'Denied', 'Not approved'],
  Resolved: ['Completed', 'Fixed', 'Repaired', 'Done'],
  Closed: ['Finalized', 'Closed out', 'Complete'],
  Archive: ['Archived', 'Filed', 'Stored'],
  Archived: ['Filed', 'Stored', 'Shelved'],
  'One Year Warranty': ['Warranty', '1-Yr warranty', 'Covered'],
};
